import { usingGet } from '@ocean/api'

export const getDashboardToken = async () => usingGet('OceanDashboard/GetOceanDashboardToken')
